import React from 'react';
import { Text } from 'react-native-web';
import { Box, BoxSizeOptions, BoxBorderOptions } from '@styleseat/ui';
import './Tag.module.scss';

export type TagProps = {
  type?: 'default' | 'chill' | 'petal' | 'spark' | 'sunshine' | 'green' | 'lightGrey';
  borderRadius?: number,
  className?: string,
  testID?: string,
  styleName?: string,
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase',
  fontWeight?: '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900' | 'normal' | 'bold',
  color?: string | null,
  textColor?: string | null,
  paddingX?: BoxSizeOptions | null,
  paddingY?: BoxSizeOptions | null,
  borderWidth?: BoxBorderOptions,
  borderStyle?: string,
  borderColor?: string,
};

const Tag: React.FC<TagProps> = ({
  children,
  type = 'default',
  borderRadius = 5,
  textTransform = 'uppercase',
  fontWeight = 'bold',
  color = null,
  textColor = null,
  paddingX = 8,
  paddingY = 2,
  className,
  testID,
  borderWidth,
  borderStyle,
  borderColor,
}) => (
  <Box
    className={className}
    paddingX={paddingX}
    paddingY={paddingY}
    borderRadius={borderRadius}
    borderWidth={borderWidth}
    borderStyle={borderStyle}
    borderColor={borderColor}
    color={color}
    styleName={`label ${type}`}
    testID={testID}
  >
    <Text
      style={{
        textTransform,
        fontWeight,
        ...(textColor && { color: textColor }),
      }}
    >
      {children}
    </Text>
  </Box>
);

export default Tag;
